var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashBookingFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14.5704,
    height: 17.4845,
    fill: "#202124"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 15.2887H12.0871",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7603 6.04106L10.4697 7.0606H4.93213L5.22268 6.04106H10.7603ZM8.16241 12.9142L5.03468 8.97664L5.01759 8.23835H6.57291C6.9774 8.23835 7.32208 8.17975 7.60694 8.06257C7.89179 7.94245 8.10971 7.76374 8.26068 7.52643C8.41166 7.28619 8.48714 6.98443 8.48714 6.62115C8.48714 6.08501 8.33047 5.6646 8.01713 5.35991C7.70379 5.05229 7.22238 4.89848 6.57291 4.89848H4.93213L5.22268 3.91409H6.57291C7.26796 3.91409 7.83767 4.03275 8.28205 4.27005C8.72927 4.50443 9.05971 4.8267 9.27335 5.23686C9.48984 5.64409 9.59809 6.10552 9.59809 6.62115C9.59809 7.08697 9.49839 7.51617 9.29899 7.90876C9.10244 8.29841 8.78624 8.61189 8.35041 8.84919C7.91743 9.0865 7.34487 9.20515 6.63273 9.20515H6.60709L9.49554 12.8439V12.9142H8.16241ZM10.7603 3.91409L10.4697 4.93363L6.11144 4.89848L6.40199 3.91409H10.7603Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 1.00158H2.43067C1.98319 0.960932 1.07245 1.70887 1.00928 2.74945V19.4556",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4992 1.00146V18.236H2.78559C2.1407 18.2089 0.882501 18.5124 1.00885 19.9432C0.969365 20.2142 1.1194 20.8049 2.03541 21L15.4992 20.7968",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4995 18.2772C15.2626 18.6566 14.9309 19.6836 15.4995 20.7567",
    stroke: "#202124",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBookingFilled);
export default __webpack_public_path__ + "static/media/cash-booking-filled.85d9a21e4c2f7b47742831315eb1fbfa.svg";
export { ForwardRef as ReactComponent };